import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

export interface ViewDeltaFilters {
  nameFilter: string;
  deltaType: string[] | null;
  type: string | null;
  viewMode?: 'basic' | 'expert';
}

@Component({
  selector: 'biz-view-delta-filters',
  templateUrl: './view-delta-filters.component.html',
  styleUrls: ['./view-delta-filters.component.scss']
})
export class ViewDeltaFiltersComponent {
  @Input() nameFilter: string = '';
  @Input() comparisonTypes: string[] = [];
  @Input() objectTypes: string[] = [];
  @Input() selectedDeltaTypes: string[] = [];
  @Input() selectedType: string | null = null;
  @Input() selectedViewMode: 'basic' | 'expert' = 'basic';

  constructor(private translateService: TranslateService) {}

  get sortedComparisonTypes(): string[] {
    return [...this.comparisonTypes].sort((a, b) => {
      const translationA = this.translateService.instant('VIEW_DELTA.COMPARISON_TYPES.' + a.trim().toUpperCase());
      const translationB = this.translateService.instant('VIEW_DELTA.COMPARISON_TYPES.' + b.trim().toUpperCase());
      return translationA.localeCompare(translationB);
    });
  }

  get sortedObjectTypes(): string[] {
    return [...this.objectTypes].sort((a, b) => {
      const translationA = this.translateService.instant('OBJECT_TYPES.' + a.trim().toUpperCase());
      const translationB = this.translateService.instant('OBJECT_TYPES.' + b.trim().toUpperCase());
      return translationA.localeCompare(translationB);
    });
  }

  @Output() filtersChange = new EventEmitter<ViewDeltaFilters>();

  isCollapsed: boolean = false;

  onToggleCollapse() {
    this.isCollapsed = !this.isCollapsed;
  }

  onSearchChange(value: string) {
    this.nameFilter = value;
    this.emitChange();
  }

  onDeltaTypeChange(value: string[]) {
    this.selectedDeltaTypes = value || [];
    this.emitChange();
  }

  onTypeChange(value: string | null) {
    this.selectedType = value || null;
    this.emitChange();
  }

  onViewModeChange(value: 'basic' | 'expert') {
    this.selectedViewMode = value || 'basic';
    this.emitChange();
  }

  cleanFilters() {
    this.nameFilter = '';
    this.selectedDeltaTypes = [];
    this.selectedType = null;
    this.selectedViewMode = 'basic';
    this.emitChange();
  }

  private emitChange() {
    this.filtersChange.emit({
      nameFilter: this.nameFilter || '',
      deltaType: this.selectedDeltaTypes.length > 0 ? this.selectedDeltaTypes : null,
      type: this.selectedType || null,
      viewMode: this.selectedViewMode || 'basic'
    });
  }
}
